export * from './dio.model';
export * from './dio.component';
export * from './dio.service';
export * from './demandante.service';
export * from './afericao.service';

export * from './aferir-dio/aferir-dio.component';
export * from './aferir-dio/registrar-apontamento/registrar-apontamento.component';

export * from './associar-condutor/associar-condutor.component';
export * from './form-dio/form-dio.component';
export * from './print-dio/print-dio.component';

export * from './view-dio/assinatura-dio/assinatura-dio.component';
export * from './view-dio/cancelar-dio/cancelar-dio.component';
export * from './view-dio/view-dio.component';
